<div class="container-fuild mt-1 ml-1">
    <!-- สถานะแปลงว่าสามารถแก้ไขได้หรือไม่ -->
    <div class="row">
        <div class="col-6">
            <div class="card card-outline px-2 mx-auto" [ngClass]="plotCanEdit==true ? 'card-success' : 'card-danger'">
                <form #frm_editToFirebase="ngForm"
                    (ngSubmit)="saveEditPlot(frm_editToFirebase.value);frm_editToFirebase.resetForm()" novalidate>

                    <input #fb_itid="ngModel" ngModel name="fb_itid" [(ngModel)]="cpDetail.itid" type="hidden" required
                        [ngClass]="{ 'is-invalid' : fb_itid.invalid && (fb_itid.dirty || fb_itid.touched )}">
                    <input #fb_year="ngModel" ngModel name="fb_year" [(ngModel)]="cpDetail.year" type="hidden" required
                        [ngClass]="{ 'is-invalid' : fb_year.invalid && (fb_year.touched || fb_year.dirty)}">
                    <input #fb_edit_type="ngModel" ngModel name="fb_edit_type" [(ngModel)]="editDetail.edit_type"
                        type="hidden" required
                        [ngClass]="{ 'is-invalid' : fb_edit_type.invalid && (fb_edit_type.touched || fb_edit_type.dirty)}">
                    <input #fb_edit_from="ngModel" ngModel name="fb_edit_from" [(ngModel)]="editDetail.edit_from"
                        type="hidden">
                    <input #fb_edit_to="ngModel" ngModel name="fb_edit_to" [(ngModel)]="editDetail.edit_to"
                        type="hidden">
                    <input #fb_edit_to_fname="ngModel" ngModel name="fb_edit_to_fname"
                        [(ngModel)]="editDetail.edit_to_fname" type="hidden">
                    <input #fb_edit_to_lname="ngModel" ngModel name="fb_edit_to_lname"
                        [(ngModel)]="editDetail.edit_to_lname" type="hidden">
                    <input #fb_edit_to_canename="ngModel" ngModel name="fb_edit_to_canename"
                        [(ngModel)]="editDetail.edit_to_canename" type="hidden">
                    <input #fb_newlandno="ngModel" ngModel name="fb_newlandno" [(ngModel)]="newLandno"
                        type="hidden">

                    <div class="direct-chat-msg" [ngClass]="plotCanEdit==true ? 'text-success' : 'text-danger'">
                        <div class="direct-chat-infos clearfix">
                            <span class="direct-chat-name float-left headText mb-2">
                                แปลง {{ cpDetail.intlandno }} {{ cpDetail.fmname }} {{ cpDetail.CaneTypeName }}
                                {{ cpDetail.landvalue }} ไร่ รูท {{ cpDetail.route }}
                            </span>
                        </div>
                        <i class="fas fa-user-edit direct-chat-img"></i>
                        <div class="direct-chat-text">
                            <p *ngIf="editDetail.edit_type==1"> <strong> {{ editDetail.edit_type_name }}
                                </strong> เนื่องจาก {{ editDetail.comment }} </p>
                            <p *ngIf="editDetail.edit_type==2" class="headText"> <strong>{{ editDetail.edit_type_name
                                    }}</strong> จาก {{ editDetail.edit_from }} เป็น {{ editDetail.edit_to }} เนื่องจาก
                                {{
                                editDetail.comment
                                }} </p>
                            <p *ngIf="editDetail.edit_type==3" class="headText"> <strong>{{ editDetail.edit_type_name }}
                                </strong> จาก {{ editDetail.edit_from }} {{ editDetail.fmname }} เป็น {{
                                editDetail.edit_to }}
                                {{ editDetail.edit_to_fmname }} เนื่องจาก {{ editDetail.comment }}
                            </p>
                        </div>
                        <span *ngIf="!plotCanEdit || !plotCanEdit2 || !plotCanEdit3" class="headText2 mt-2 mb-2 icon-animated-vertical">
                            <i class="	fas fa-ban"></i>
                            !!ยังไม่สามารถแก้ไขได้ เนื่องจากติด 
                            <span *ngIf="!plotCanEdit">รายการขอเกี้ยว</span> / 
                            <span *ngIf="!plotCanEdit2">รายการขอปัจจัยฯ</span>  / 
                            <span *ngIf="!plotCanEdit3">บาทต่อตันเกิน</span>
                        </span>
                        <div *ngIf="editDetail.edit_type==3" class="container">
                            <blockquote class="blockquote">
                                <div class="form-group">
                                    <div class="input-group mb-3">
                                        <div class="input-group-prepend">
                                          <span class="input-group-text">เลือกโซนปลายทาง</span>
                                        </div>
                                        <select (change)="getNewLandno(frm_editToFirebase.value)" #s_supzone="ngModel" ngModel name="s_supzone" class="form-control">
                                            <option value="" disabled>++เลือกโซน++</option>
                                            <option *ngFor="let item of supzone" [value]="item.supzone">{{ item.zonename }}</option>
                                        </select>
                                      </div>
                                </div>
                                <p>กรณีแก้ไขเจ้าของแปลง แปลงนี้จะถูกแก้ไขเป็น โควตา {{ editDetail.edit_to }} หมายเลขแปลง {{ newLandno }} </p>
                                <!-- <footer class="blockquote-footer">เลือกโซนของแปลงอ้อย</footer> -->
                            </blockquote>
                        </div>
                        <button (click)="saveEditPlot(frm_editToFirebase.value)" *ngIf="plotCanEdit && plotCanEdit2 && plotCanEdit3"
                            [disabled]="frm_editToFirebase.invalid" class="btn btn-block btn-outline-success mt-2">
                            <i class="fas fa-check-double"></i> สามารถแก้ไขข้อมูลแปลงอ้อยได้ OK คลิกเลย
                        </button>
                        <!-- <p> form: {{ frm_editToFirebase.value | json }} </p> -->
                    </div>
                </form>

            </div>
        </div>
        <div class="col-2">
            <div *ngIf="haveFinance" class="small-box bg-success">
                <div class="inner">
                    <h3>การเบิกเกี้ยว</h3>
                    <p>ไม่พบรายการเบิกเกี้ยว</p>
                </div>
                <div class="icon text-white">
                    <i class="fas fa-check-double"></i>
                </div>
                <a href="#" class="small-box-footer">
                    More info <i class="fas fa-arrow-circle-right"></i>
                </a>
            </div>
            <div *ngIf="!haveFinance" class="small-box bg-danger">
                <div class="inner">
                    <h3>การเบิกเกี้ยว</h3>
                    <p>!!พบการเบิกเกี้ยว</p>
                </div>
                <div class="icon text-white">
                    <i class="fas fa-ban"></i>
                </div>
                <a href="#" class="small-box-footer">
                    More info <i class="fas fa-arrow-circle-right"></i>
                </a>
            </div>
        </div>
        <div class="col-2">
            <div *ngIf="haveFactor" class="small-box bg-success">
                <div class="inner">
                    <h3>การเบิกปัจจัยฯ</h3>
                    <p>ไม่พบการเบิกปัจจัยฯ</p>
                </div>
                <div class="icon text-white">
                    <i class="fas fa-check-double"></i>
                </div>
                <a href="#" class="small-box-footer">
                    More info <i class="fas fa-arrow-circle-right"></i>
                </a>
            </div>
            <div *ngIf="!haveFactor" class="small-box bg-danger">
                <div class="inner">
                    <h3>การเบิกปัจจัยฯ</h3>
                    <p>!!พบการเบิกปัจจัยฯ</p>
                </div>
                <div class="icon text-white">
                    <i class="fas fa-ban"></i>
                </div>
                <a href="#" class="small-box-footer">
                    More info <i class="fas fa-arrow-circle-right"></i>
                </a>
            </div>
        </div>
        <div class="col-2">
            <div *ngIf="btOver" class="small-box bg-success">
                <div class="inner">
                    <h3>{{ btfm.btAll | number:'1.0-0'  }}</h3>
                    <p>บาทต่อตันของชาวไร่</p>
                </div>
                <div class="icon text-white">
                    <i class="fas fa-check-double"></i>
                </div>
                <a href="#" class="small-box-footer">
                    More info <i class="fas fa-arrow-circle-right"></i>
                </a>
            </div>
            <div *ngIf="!btOver" class="small-box bg-danger">
                <div class="inner">
                    <h3>{{ btfm.btAll | number:'1.0-0'  }}</h3>
                    <p>!! บาทต่อตันเกิน 650</p>
                </div>
                <div class="icon text-white">
                    <i class="fas fa-check-double"></i>
                </div>
                <a href="#" class="small-box-footer">
                    More info <i class="fas fa-arrow-circle-right"></i>
                </a>
            </div>
        </div>
    </div>

    <!-- ข้อมูลจาก firebase -->
    <!-- <div class="row">
         <div class="card card-outline card-primary"> -->
            <!-- <p class="headText1"> ข้อมูลจาก Farmluck </p>
             <p>{{ cpFibaseDetail | json }}</p> -->
            <!-- <p>
                แปลง {{ cpFibaseDetail.landno }} 
                โควตา {{ cpFibaseDetail.bnm_profile.code }} 
                ประเภท {{ cpFibaseDetail.DetailPlant.CaneTypeName }}  
                พื้นที่ {{ cpFibaseDetail.DetailPlant.AreaPre | number }}
            </p> -->
        <!-- </div>
    </div> -->

    <!-- การโอนย้ายเกี้ยว และ ปัจจัยการผลิต -->
    <div class="row">
        <div *ngIf="!plotCanEdit" class="col-6">
            <div class="card card-outline card-primary">
                <div class="card-header">
                    <strong class="headText1"><i class="fas fa-money-check-alt"></i> การโอนย้ายเกี้ยวไปแปลงอื่น
                    </strong>
                </div>
                <div class="card-body">
                    <span *ngIf="haveFinance" class="headText text-success">
                        <i class="fas fa-check-circle"></i>
                        ไม่พบรายการขอเกี้ยว ของแปลงนี้แล้ว
                    </span>
                    <span *ngIf="!haveFinance" class="headText text-danger">
                        <i class="fas fa-ban"></i>
                        พบรายการขอเกี้ยว ของแปลงนี้ ต้องโอนย้ายไปแปลงอื่นก่อน
                    </span>
                    <ul class="list-group list-group-flush">
                        <li *ngFor="let item of financeList" class="list-group-item">
                            - คำขอ {{ item.docid }} ,
                            แปลง {{ item.intlandno }} ,
                            เมื่อ {{ item.datepost | adtob }},
                            เรื่อง {{ item.comment1 }},
                            จำนวนเงิน {{ item.money_amt | number }},
                            สถานะเกี้ยว {{ item.docdesc }}
                        </li>
                    </ul>
                    <form #frm_tranFinance="ngForm"
                        (ngSubmit)="savefrm_tranFinance(frm_tranFinance.value);frm_tranFinance.resetForm()" novalidate>
                        <div class="form-group">
                            <span class="headText text-primary">1.เลือกรายการขอเกี้ยวของแปลง</span>
                            <select (change)="docSelect($event)" #s_docid="ngModel" ngModel name="s_docid"
                                class="form-control"
                                [ngClass]="{ 'is-invalid' : s_docid.invalid && (s_docid.touched || s_docid.dirty)}"
                                required>
                                <option value="" disabled selected>++เลือกรายการขอเกี้ยว++</option>
                                <option *ngFor="let item of financeList" [value]="item.docid">
                                    เลขคำขอ {{ item.docid }}
                                    <!-- , แปลง {{ item.intlandno }} , เมื่อ {{ item.datepost | adtob }} ,
                                    {{ item.comment1 }} ,
                                    {{ item.money_amt | number }} ,
                                    {{ item.docdesc }} -->
                                </option>
                            </select>
                            <div class="invalid-feedback">
                                <span *ngIf="s_docid.hasError('required')">กรุณาเลือกรายการขอเกี้ยว</span>
                            </div>
                        </div>
                        <div class="form-group">
                            <span class="headText text-primary mt-2">2.เลือกแปลงที่ต้องการโอนเงินเกี้ยวไป <small>เลือกได้เฉพาะแปลงมีวงเงินเพียงพอ</small></span>
                            <div class="input-group">
                                <!-- <div class="input-group-prepend">
                                    <span class="input-group-text">เลือกแปลงที่ต้องการโอนเงินเกี้ยวไป</span>
                                </div> -->
                                <select (change)="showfinance($event)" #s_plot="ngModel" ngModel name="s_plot"
                                    class="form-control"
                                    [ngClass]="{ 'is-invalid' : s_plot.invalid && (s_plot.touched || s_plot.dirty)}"
                                    required>
                                    <option value="" disabled selected>++เลือกแปลง++</option>
                                    <option *ngFor="let item of listPlot" [value]="item.intlandno" [disabled]="item.credit_left < FinanceSelect[0].money_amt || item.intlandno == cpDetail.intlandno ">
                                        {{ item.intlandno }} {{ item.canetype }} {{ item.landvalue }} ไร่
                                        วงเงิน {{ item.credit_amount | number }}
                                        ใช้ไป {{ item.money_amt | number }}
                                        คงเหลือ {{ item.credit_left | number }}
                                    </option>
                                </select>
                                <div class="invalid-feedback">
                                    <span
                                        *ngIf="s_plot.hasError('required')">กรุณาเลือกหมายเลขแปลงอ้อยที่จะโอนวงเงินเกี้ยว</span>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <span class="headText text-primary mb-2">3.ตรวจสอบก่อนบันทึก</span>
                            <div *ngIf="selectDoc !=null" class="list-group mb-2"
                                style="background-color: rgb(253, 231, 197);">
                                <span class="mt-2 mb-2 headText1"> เลขที่คำขอ {{ selectDoc }} </span>
                            </div>
                            <div *ngIf="selectPlot !=null" class="list-group"
                                style="background-color: rgb(169, 253, 158);">
                                <span class="mt-2 mb-2 headText1"> เลขแปลงที่ต้องการโอนเกี้ยวไป {{ selectPlot }} </span>
                            </div>
                        </div>
                        <input type="hidden" #hitid="ngModel" name="hitid" [(ngModel)]="itid">
                        <input type="hidden" #hfmcode="ngModel" name="hfmcode" [(ngModel)]="fmcode">
                        <input type="hidden" #holdPlot="ngModel" name="holdPlot" [(ngModel)]="oldPlot">
                        <button type="submit" [disabled]="frm_tranFinance.invalid" class="btn btn-outline-primary">
                            <i class="fas fa-save"> 4. บันทึก/อัพเดต รายการขอเกี้ยว</i>
                        </button>
                        <!-- <p>Is Form Valid : {{frm_tranFinance.valid}} </p> -->
                        <!-- <p>Form : {{ frm_tranFinance.value | json}} </p> -->
                    </form>

                </div>
            </div>
        </div>
        <div *ngIf="!plotCanEdit2" class="col-6">
            <div class="card card-outline card-warning">
                <div class="card-header">
                    <strong class="headText1"><i class="fas fa-baby-carriage"></i> การโอนย้ายปัจจัยการผลิต ไปแปลงอื่น
                    </strong>
                </div>
                <div class="card-body">
                    <span *ngIf="haveFactor" class="headText text-success">
                        <i class="fas fa-check-circle"></i>
                        ไม่พบรายการขอปัจจัยการผลิต ของแปลงนี้แล้ว
                    </span>
                    <span *ngIf="!haveFactor" class="headText text-danger">
                        <i class="fas fa-ban"></i>
                        พบรายการขอปัจจัยการผลิต ของแปลงนี้ ต้องโอนย้ายไปแปลงอื่นก่อน
                    </span>

                    <ul class="list-group list-group-flush">
                        <li *ngFor="let item of factorList" class="list-group-item">
                            - เลขที่ {{ item.docid }} เมื่อ {{ item.datepost | adtob }} ,
                            <span *ngIf="item.amt1>0">{{ item.desc1 }} จำนวน {{ item.amt1 | number }} ,</span>
                            <span *ngIf="item.amt2>0">{{ item.desc2 }} จำนวน {{ item.amt2 | number }} ,</span>
                            <span *ngIf="item.amt3>0">{{ item.desc3 }} จำนวน {{ item.amt3 | number }} ,</span>
                            <span *ngIf="item.amt4>0">{{ item.desc4 }} จำนวน {{ item.amt4 | number }} ,</span>
                        </li>
                    </ul>

                    <form #frm_tranFactor="ngForm"
                        (ngSubmit)="savefrm_tranFactor(frm_tranFactor.value);frm_tranFactor.resetForm()" novalidate>
                        <div class="form-group">
                            <span class="headText text-primary">1.เลือกรายการขอปัจจัยของแปลง</span>
                            <select (change)="docSelect2($event)" #fac_docid="ngModel" ngModel name="fac_docid"
                                class="form-control"
                                [ngClass]="{ 'is-invalid' : fac_docid.invalid && (fac_docid.touched || fac_docid.dirty)}"
                                required>
                                <option value="" disabled selected>++เลือกรายการขอปัจจัย++</option>
                                <option *ngFor="let item of factorList" [value]="item.docid">
                                    คำขอ {{ item.docid }}
                                    <!-- , แปลง {{ item.intlandno }} , เมื่อ {{ item.datepost | adtob }} ,
                                    {{ item.desc1 }} | {{ item.amt1 | number }}  ,
                                    {{ item.desc2 }} | {{ item.amt2 | number }}  ,
                                    {{ item.desc3 }} | {{ item.amt3 | number }}  ,
                                    {{ item.desc4 }} | {{ item.amt4 | number }}  , -->
                                </option>
                            </select>
                            <div class="invalid-feedback">
                                <span *ngIf="fac_docid.hasError('required')">กรุณาเลือกรายการขอเกี้ยว</span>
                            </div>
                        </div>
                        <div class="form-group">
                            <span class="headText text-primary mt-2">2.เลือกแปลงที่ต้องการโอนปัจจัยไป</span>
                            <div class="input-group">
                                <!-- <div class="input-group-prepend">
                                    <span class="input-group-text">เลือกแปลงที่ต้องการโอนเงินเกี้ยวไป</span>
                                </div> -->
                                <select (change)="selectLandno2($event)" #fac_intlandno="ngModel" ngModel
                                    name="fac_intlandno" class="form-control"
                                    [ngClass]="{ 'is-invalid' : fac_intlandno.invalid && (fac_intlandno.touched || fac_intlandno.dirty)}"
                                    required>
                                    <option value="" disabled selected>++เลือกแปลง++</option>
                                    <option *ngFor="let item of listPlot2" [value]="item.intlandno" [disabled]="item.intlandno == cpDetail.intlandno">
                                        {{ item.intlandno }} {{ item.canetype }} {{ item.landvalue }} ไร่
                                    </option>
                                </select>
                                <div class="invalid-feedback">
                                    <span
                                        *ngIf="fac_intlandno.hasError('required')">กรุณาเลือกหมายเลขแปลงอ้อยที่จะโอนปัจจัยการผลิต</span>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <span class="headText text-primary mb-2">3.ตรวจสอบก่อนบันทึก</span>
                            <div *ngIf="selectDoc2 !=null" class="list-group mb-2"
                                style="background-color: rgb(253, 231, 197);">
                                <span class="mt-2 mb-2 headText1"> เลขที่คำขอ {{ selectDoc2 }} </span>
                            </div>
                            <div *ngIf="selectPlot2 !=null" class="list-group"
                                style="background-color: rgb(169, 253, 158);">
                                <span class="mt-2 mb-2 headText1"> เลขแปลงที่ต้องการโอนเกี้ยวไป {{ selectPlot2 }} </span>
                            </div>
                        </div>
                        <input type="hidden" #fac_itid="ngModel" name="fac_itid" [(ngModel)]="itid">
                        <input type="hidden" #fac_fmcode="ngModel" name="fac_fmcode" [(ngModel)]="fmcode">
                        <input type="hidden" #fac_oldPlot="ngModel" name="fac_oldPlot" [(ngModel)]="oldPlot">
                        <button type="submit" [disabled]="frm_tranFactor.invalid" class="btn btn-outline-primary">
                            <i class="fas fa-save"> 4. บันทึก/อัพเดต รายการขอปัจจัย</i>
                        </button>
                        <!-- <p>Is Form Valid : {{frm_tranFinance.valid}} </p> -->
                        <!-- <p>Form : {{ frm_tranFactor.value | json}} </p> -->
                    </form>

                </div>

            </div>

        </div>
    </div>
</div>

<!-- <div class="row mt-1 mb-2" style="background-color: rgb(253, 231, 197);">
                            <div class="col-sm-4 border-right text-success">
                              <div class="description-block">
                                <h5 class="description-header">{{ plotSelect.credit_amount | number }}</h5>
                                <span class="description-text">วงเงิน</span>
                              </div>
                            </div>
                            <div class="col-sm-4 border-right text-warning">
                              <div class="description-block">
                                <h5 class="description-header">{{ plotSelect.money_amt | number }}</h5>
                                <span class="description-text">ใช้ไป</span>
                              </div>
                            </div>
                            <div class="col-sm-4">
                              <div class="description-block text-danger">
                                <h5 class="description-header">{{ plotSelect.credit_left | number }}</h5>
                                <span class="description-text">คงเหลือ</span>
                              </div>
                            </div>
                        </div> -->